export const TURNITIN_REQUEST = 'TURNITIN_REQUEST';
export const TURNITIN_SUCCESS = 'TURNITIN_SUCCESS';
export const TURNITIN_FAILURE = 'TURNITIN_FAILURE';

export const TURNITIN_EULA_REQUEST = 'TURNITIN_EULA_REQUEST';
export const TURNITIN_EULA_SUCCESS = 'TURNITIN_EULA_SUCCESS';
export const TURNITIN_EULA_FAILURE = 'TURNITIN_EULA_FAILURE';

export const TURNITIN_GET_EULA_REQUEST = 'TURNITIN_GET_EULA_REQUEST';
export const TURNITIN_GET_EULA_SUCCESS = 'TURNITIN_GET_EULA_SUCCESS';
export const TURNITIN_GET_EULA_FAILURE = 'TURNITIN_GET_EULA_FAILURE';


export const TURNITIN_SUBMISSION_REQUEST = 'TURNITIN_SUBMISSION_REQUEST';
export const TURNITIN_SUBMISSION_SUCCESS = 'TURNITIN_SUBMISSION_SUCCESS';
export const TURNITIN_SUBMISSION_FAILURE = 'TURNITIN_SUBMISSION_FAILURE';

export const TURNITIN_DO_SUBMISSION_REQUEST = 'TURNITIN_DO_SUBMISSION_REQUEST';
export const TURNITIN_DO_SUBMISSION_SUCCESS = 'TURNITIN_DO_SUBMISSION_SUCCESS';
export const TURNITIN_DO_SUBMISSION_FAILURE = 'TURNITIN_DO_SUBMISSION_FAILURE';

export const TURNITIN_GENERATE_REQUEST = 'TURNITIN_GENERATE_REQUEST';
export const TURNITIN_GENERATE_SUCCESS = 'TURNITIN_GENERATE_SUCCESS';
export const TURNITIN_GENERATE_FAILURE = 'TURNITIN_GENERATE_FAILURE';

export const TURNITIN_REPORT_REQUEST = 'TURNITIN_REPORT_REQUEST';
export const TURNITIN_REPORT_SUCCESS = 'TURNITIN_REPORT_SUCCESS';
export const TURNITIN_REPORT_FAILURE = 'TURNITIN_REPORT_FAILURE';

export const TURNITIN_LINK_REQUEST = 'TURNITIN_LINK_REQUEST';
export const TURNITIN_LINK_SUCCESS = 'TURNITIN_LINK_SUCCESS';
export const TURNITIN_LINK_FAILURE = 'TURNITIN_LINK_FAILURE';

export const SET_REQUEST_ID = 'SET_REQUEST_ID';
export const SELECT_CONTENT = 'SELECT_CONTENT';
export const SHOW_TURNITIN_RESULTS = 'SHOW_TURNITIN_RESULTS';
export const SET_RESULTS = 'SET_RESULTS';
export const TURNITIN_SHOW_LINK = 'TURNITIN_SHOW_LINK';
export const SET_EULA_VERSION = 'SET_EULA_VERSION';
export const SET_EULA_ACCEPTANCE = 'SET_EULA_ACCEPTANCE';
export const CLEAR_EULA_ACCEPTANCE = 'CLEAR_EULA_ACCEPTANCE';
export const turnitinRequest = () => ({
  type: TURNITIN_REQUEST,
});

export const turnitinSuccess = payload => ({
  type: TURNITIN_SUCCESS,
  payload,
});
export const turenitinShowLink = payload => ({
  type: TURNITIN_SHOW_LINK,
  payload,
});

export const setResults = payload => ({
  type: SET_RESULTS,
  payload,
});
export const showTurnitinResults = payload => ({
  type: SHOW_TURNITIN_RESULTS,
  payload,
});
export const setRequestId = payload => ({
  type: SET_REQUEST_ID,
  payload,
});

export const turnitinFailure = payload => ({
  type: TURNITIN_FAILURE,
  payload,
});


export const turnitinReportRequest = () => ({
  type: TURNITIN_REPORT_REQUEST,
});

export const turnitinReportSuccess = payload => ({
  type: TURNITIN_REPORT_SUCCESS,
  payload,
});

export const turnitinReportFailure = payload => ({
  type: TURNITIN_REPORT_FAILURE,
  payload,
});
export const turnitinLinkRequest = () => ({
  type: TURNITIN_LINK_REQUEST,
});

export const turnitinLinkSuccess = payload => ({
  type: TURNITIN_LINK_SUCCESS,
  payload,
});

export const turnitinLinkFailure = payload => ({
  type: TURNITIN_LINK_FAILURE,
  payload,
});
export const turnitinEulaRequest = () => ({
  type: TURNITIN_EULA_REQUEST,
});

export const turnitinEulaSuccess = payload => ({
  type: TURNITIN_EULA_SUCCESS,
  payload,
});

export const turnitinGetEulaFailure = payload => ({
  type: TURNITIN_GET_EULA_FAILURE,
  payload,
});

export const turnitinGetEulaRequest = () => ({
  type: TURNITIN_GET_EULA_REQUEST,
});

export const turnitinGetEulaSuccess = payload => ({
  type: TURNITIN_GET_EULA_SUCCESS,
  payload,
});

export const turnitinEulaFailure = payload => ({
  type: TURNITIN_EULA_FAILURE,
  payload,
});

export const turnitinSubmissionRequest = () => ({
    type: TURNITIN_SUBMISSION_REQUEST,
  });
  
  export const turnitinSubmissionSuccess = payload => ({
    type: TURNITIN_SUBMISSION_SUCCESS,
    payload,
  });
  
  export const turnitinSubmissionFailure = payload => ({
    type: TURNITIN_SUBMISSION_FAILURE,
    payload,
  });

  export const turnitinDoSubmissionRequest = () => ({
    type: TURNITIN_DO_SUBMISSION_REQUEST,
  });
  
  export const turnitinDoSubmissionSuccess = payload => ({
    type: TURNITIN_DO_SUBMISSION_SUCCESS,
    payload,
  });
  
  export const turnitinDoSubmissionFailure = payload => ({
    type: TURNITIN_DO_SUBMISSION_FAILURE,
    payload,
  });

  export const turnitinGenerateRequest = () => ({
    type: TURNITIN_GENERATE_REQUEST,
  });
  
  export const turnitinGenerateSuccess = payload => ({
    type: TURNITIN_GENERATE_SUCCESS,
    payload,
  });
  export const turnitInShowLink = payload => ({
    type: TURNITIN_SHOW_LINK,
    payload,
  });
  
  export const turnitinGenerateFailure = payload => ({
    type: TURNITIN_GENERATE_FAILURE,
    payload,
  });

  export const selecContent = payload => ({
    type: SELECT_CONTENT,
    payload,
  });

export const setEulaVersion = payload => ({
  type: SET_EULA_VERSION,
  payload,
});

export const setEulaAcceptance = payload => ({
  type: SET_EULA_ACCEPTANCE,
  payload,
});

export const clearEulaAcceptance = () => ({
  type: CLEAR_EULA_ACCEPTANCE,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  eula: false,
  eulaVersion: null,
  eulaAcceptedTimestamp: null,
  eulaLanguage: null,
  statementid: null,
  report:null,
  request_id:null,
  doc_url:null,
  allowance: 0,
  attempt:0,
  selectedContent:null,
  submissionContext:null,
  showTurnitinResults:false,
  results:null,
  link:null
};

export function turnitinReducer(state = initialState, action) {
  switch (action.type) {
    case TURNITIN_LINK_SUCCESS:
      return {
        ...state,
        fetching: true,
        isFetched: false,
        link:action.payload
      };
      case TURNITIN_LINK_REQUEST:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
        case TURNITIN_LINK_FAILURE:
          return {
            ...state,
            fetching: true,
            isFetched: false,
          };
      case SET_RESULTS:
        return {
          ...state,
          results:action.payload
        };
    case SHOW_TURNITIN_RESULTS:
      return {
        ...state,
        showTurnitinResults:action.payload
      };
    case SELECT_CONTENT:
      return {
        ...state,
        selectedContent:action.payload
      };
    case SET_REQUEST_ID:
        return {
          ...state,
          request_id:action.payload.request_id,
          doc_url:action.payload.tii_url,
          allowance:action.payload.submission_allowance,
          attempt:action.payload.attempt,
          submissionContext:action.payload,
        };
    case TURNITIN_REPORT_REQUEST:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_REPORT_SUCCESS:
        return {
          ...state,
          fetching: true,
          isFetched: false,
          report:action.payload
        };
    case TURNITIN_REPORT_FAILURE:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_GENERATE_REQUEST:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_GENERATE_SUCCESS:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_GENERATE_FAILURE:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_DO_SUBMISSION_REQUEST:
       
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_DO_SUBMISSION_FAILURE:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_DO_SUBMISSION_SUCCESS:
     
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_SUBMISSION_REQUEST:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_SUBMISSION_SUCCESS:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
    case TURNITIN_SUBMISSION_FAILURE:
        return {
          ...state,
          fetching: true,
          isFetched: false,
        };
   
    case TURNITIN_REQUEST:
      return {
        ...state,
        fetching: true,
        isFetched: false,
      };
    case TURNITIN_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        statementid:action.payload.id
      };
    case TURNITIN_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,

      };

      case TURNITIN_EULA_REQUEST:
      return {
        ...state,
        fetching: true,
        isFetched: false,
      };
    case SET_EULA_VERSION:
      return {
        ...state,
        eulaVersion: action.payload.version,
      };
    case SET_EULA_ACCEPTANCE:
      return {
        ...state,
        eula: true,
        eulaVersion: action.payload.version,
        eulaAcceptedTimestamp: action.payload.accepted_timestamp,
        eulaLanguage: action.payload.language,
      };
    case CLEAR_EULA_ACCEPTANCE:
      return {
        ...state,
        eula: false,
        eulaAcceptedTimestamp: null,
        eulaLanguage: null,
      };
    case TURNITIN_EULA_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        eula: true,
        eulaVersion: action.payload.version || state.eulaVersion,
        eulaAcceptedTimestamp: action.payload.accepted_timestamp || state.eulaAcceptedTimestamp,
        eulaLanguage: action.payload.language || state.eulaLanguage,
      };
    case TURNITIN_EULA_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,

      };
    default:
      return state;
  }
}
